import { _ as _tagged_template_literal } from "@swc/helpers/_/_tagged_template_literal";
function _templateObject() {
    const data = _tagged_template_literal([
        "\n  .MuiBox-root {\n    width: 100%;\n  }\n  .MuiPaper-root {\n    overflow: hidden;\n\n    @media (max-width: 1200px) {\n      width: 360px;\n    }\n    @media (max-width: 768px) {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _tagged_template_literal([
        "\n  width: 100%;\n  max-height: calc(100vh - 128px); // 상단 + 하단 앱바 고려\n  padding: 28px 20px 0 20px;\n  overflow-y: auto;\n\n  @media (max-width: 1023px) {\n    max-height: calc(100vh - 48px - ",
        "px);\n  }\n"
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: space-between;\n\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 30px; /* 150% */\n\n  margin-bottom: 8px;\n  color: ",
        ";\n"
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { appBarHeight } from "@/components/@common/AppBar/AppBar";
import { Box, Drawer } from "@mui/material";
import { useEffect, useState } from "react";
import styled from "styled-components";
import { isInWebview } from "src/utils/misc";
import { useAppBarStore } from "src/store/appBar.store";
/**
 * 앱바 가시성에 따른 bottom offset 계산 훅
 * - 웹뷰: 앱바 없음 → 0
 * - 브라우저 + 앱바 보임 → appBarHeight
 * - 브라우저 + 앱바 숨김 → 0
 */ const useBottomOffset = ()=>{
    const { isVisible  } = useAppBarStore();
    const [isWebview, setIsWebview] = useState(false);
    useEffect(()=>{
        setIsWebview(isInWebview());
    }, []);
    return !isWebview && isVisible ? appBarHeight : 0;
};
const AnchorDrawer = (param)=>{
    let { open , onClose , anchor ="bottom" , children , ...props } = param;
    const bottomOffset = useBottomOffset();
    return /*#__PURE__*/ _jsx(DrawerBox, {
        anchor: anchor,
        open: open,
        onClose: onClose,
        transitionDuration: {
            enter: 500,
            exit: 400
        },
        sx: anchor === "bottom" ? {
            ".MuiPaper-root": {
                borderRadius: "12px 12px 0 0",
                // 앱바(lg:hidden) 위에 표시되도록 bottom 값 조정 (웹뷰에서는 앱바 없음)
                "@media (max-width: 1023px)": {
                    bottom: "".concat(bottomOffset, "px"),
                    maxHeight: "calc(100vh - 48px - ".concat(bottomOffset, "px)")
                }
            },
            maxHeight: "calc(100vh - 128px)"
        } : {},
        ...props,
        children: /*#__PURE__*/ _jsx(Box, {
            sx: {
                width: anchor === "bottom" || anchor === "top" ? "100%" : "250px"
            },
            children: children
        })
    });
};
const Contents = (param)=>{
    let { children  } = param;
    const bottomOffset = useBottomOffset();
    return /*#__PURE__*/ _jsx(BottomBox, {
        $bottomOffset: bottomOffset,
        children: children
    });
};
const Title = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(TitleText, {
        children: children
    });
};
AnchorDrawer.Contents = Contents;
AnchorDrawer.Title = Title;
export const DrawerBox = styled(Drawer).withConfig({
    componentId: "sc-a3cc3cfa-0"
})(_templateObject());
const BottomBox = styled.div.withConfig({
    componentId: "sc-a3cc3cfa-1"
})(_templateObject1(), (props)=>props.$bottomOffset);
const TitleText = styled.p.withConfig({
    componentId: "sc-a3cc3cfa-2"
})(_templateObject2(), (props)=>props.theme.new.colors.sol_gray_900);
export default AnchorDrawer;
